import { Skeleton, Stack } from '@mui/material';

import { Container } from './MeetingDataStyles';

const MeetingDataSkeleton = () => (
  <Container>
    <Skeleton
      variant="rounded"
      sx={{
        borderRadius: '30px',
        height: '46px',
        width: '525px'
      }}
    />
    <Stack marginTop="70px" gap="24px">
      {Array.from({ length: 6 }).map((_, index) => (
        <Skeleton
          key={index}
          sx={{
            borderRadius: '30px'
          }}
          variant="rounded"
          width="403px"
          height="24px"
          animation="wave"
        />
      ))}
      <Skeleton
        sx={{
          borderRadius: '30px'
        }}
        variant="rounded"
        width="288px"
        height="24px"
        animation="wave"
      />
    </Stack>
  </Container>
);

export default MeetingDataSkeleton;
